import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { Warning, X, CaretRight } from "@phosphor-icons/react";

// A2: bookings whose dates are unusable are excluded from every total here.
export function DateIssuesNotice() {
  const [hidden, setHidden] = useState(false);
  const [openList, setOpenList] = useState(false);
  const { data } = useQuery({
    queryKey: ["date-issues"],
    queryFn: async () => (await api.get("/financials/date-issues")).data,
  });
  const count = data?.count || 0;
  if (hidden || !count) return null;

  return (
    <div className="border border-amber-500/40 bg-amber-500/[0.06]" data-testid="date-issues-notice">
      <div className="flex items-center gap-3 px-4 py-3">
        <Warning size={16} className="text-amber-400 shrink-0" />
        <span className="text-sm flex-1">
          {count} booking{count === 1 ? " has" : "s have"} unusable dates and {count === 1 ? "is" : "are"} excluded from these totals.
        </span>
        <button onClick={() => setOpenList((v) => !v)} className="text-xs text-primary hover:underline underline-offset-4" data-testid="date-issues-toggle">
          {openList ? "Hide list" : "Review them"}
        </button>
        <button onClick={() => setHidden(true)} className="text-muted-foreground hover:text-foreground" data-testid="date-issues-dismiss">
          <X size={14} />
        </button>
      </div>
      {openList && (
        <div className="border-t border-amber-500/25 max-h-72 overflow-y-auto divide-y divide-amber-500/10">
          {(data?.rows || []).map((r) => (
            <a key={r.id} href={`/bookings/view/${r.id}`} className="flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-amber-500/[0.06]" data-testid={`date-issue-row-${r.id}`}>
              <span className="flex-1 min-w-0 truncate">
                {r.customer_name || "Guest"}
                <span className="text-muted-foreground"> · {r.booking_type} · {r.vehicle_label || "no car"}</span>
              </span>
              <span className="text-xs text-muted-foreground tnum">
                {r.start_datetime || "—"} → {r.end_datetime || "—"}
              </span>
              <CaretRight size={12} className="text-muted-foreground" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
